// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2Xp2a","title":"Images45_title__13Fw0","images":"Images45_images__1jSwn"};